import MDButton from 'components/MDButton'
import React, { useEffect, useState } from 'react'
import MDModal from 'components/MDModal'
import MDBox from 'components/MDBox'
import MDTypography from 'components/MDTypography'
import { Edit } from '@mui/icons-material'
import {
  Button,
  FormControl,
  InputLabel,
  MenuItem,
  Select,
  Stack,
  TextField,
  TextareaAutosize,
} from '@mui/material'
import { useAppServices, useUploadImage } from 'hook/services'
import { useUserInfo } from 'context/user'
import FormField from 'components/FormField'
import MDInput from 'components/MDInput'
import Multiselect from './components/Multiselect'
import { useAgencyInfo } from 'context/agency'

const CreateModal = ({ teamTags, handleRefresh }) => {
  const [agency] = useAgencyInfo()

  const uploadImage = useUploadImage()
  const [openAddProduct, setOpenAddProduct] = useState(false)
  const AppService = useAppServices()
  const [selectedRoles, setSelectedRoles] = useState([])
  const [tags, setTags] = useState([])

  const [user] = useUserInfo()

  const handleKeyPress = (e) => {
    if (e.key === 'Enter') {
      e.preventDefault() // Add this line to prevent form submission
      const value = e.target.value.trim()
      if (value && !tags.includes(value)) {
        setTags([...tags, value])
        e.target.value = ''
      }
    }
  }

  const team_tags = teamTags?.map((item) => {
    return {
      label: item?.name,
      value: item?.name?.toLowerCase().replace(/\s+/g, '-'),
    }
  })

  const style = {
    position: 'absolute',
    top: '50%',
    left: '50%',
    transform: 'translate(-50%, -50%)',
    width: 440,
    bgcolor: 'background.paper',
    borderRadius: '10px',
    boxShadow: 24,
    p: 4,
  }

  const permissions = [
    { label: 'Agent', value: 'agent' },
    { label: 'Developer', value: 'developer' },
    { label: 'Manager', value: 'manager' },
    { label: 'Support', value: 'support' },
    { label: 'Superadmin', value: 'superadmin' },
    { label: 'Graphics', value: 'graphics' },
    { label: 'Client Handling', value: 'client_handling' },
    { label: 'Social Media', value: 'social' },
    { label: 'Onboarding Admin', value: 'onboarding_admin' },
    { label: 'Client', value: 'client' },
  ]
  const handlemodal = () => setOpenAddProduct(true)
  const closeAddProduct = () => setOpenAddProduct(false)

  function AddProduct({ open, onClose }) {
    const [processing, setProcessing] = useState(false)

    const handleSubmit = async (e) => {
      e.preventDefault()
      const roles = JSON.parse(e.target.roles.value)

      const data = {
        username: e.target.username.value,
        email: e.target.email.value,
        password: e.target.password.value,
        roles: roles?.map((item) => item.value),
        type: 'super_admin_team',
        agency_id: agency._id,
        tags: e.target.tags ? JSON.parse(e.target.tags.value) : [],
        app_id: e.target.app_id.value,
      }
      const payload = { data }

      const { response } = await AppService.auth.CreateTeam({ payload })
      if (response) {
        setProcessing(false)
        onClose()
        handleRefresh()
      }
    }
    const handleRoleChange = (selected) => {
      setSelectedRoles(selected.map((item) => item.value))
    }

    return (
      <MDModal open={open} onClose={onClose} width={440}>
        <MDBox sx={style}>
          <MDTypography variant="h5" mb={2}>
            Create Team User
          </MDTypography>
          <MDBox component="form" onSubmit={handleSubmit} role="form">
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Name
            </MDTypography>
            <MDInput label="Name" placeholder="Name" name="username" fullWidth />

            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Email
            </MDTypography>
            <MDInput label="Email" placeholder="Email" name="email" fullWidth />

            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Password
            </MDTypography>
            <MDInput
              label="Password"
              type="password"
              placeholder="Password"
              name="password"
              fullWidth
            />

            {/* <MDBox mb={2}>
              <MDTypography variant="button">Tags</MDTypography>
              <MDInput label="Add tags" onKeyDown={handleKeyPress} fullWidth />
              <MDBox display="flex" flexWrap="wrap" gap={1} mt={1}>
                {tags.map((tag, index) => (
                  <MDBox key={index} bgcolor="grey.200" px={1} borderRadius="5px" display="flex" alignItems="center">
                    <MDTypography variant="caption" color="info">{tag}</MDTypography>
                    <MDTypography variant="caption" onClick={() => setTags(tags.filter((_, i) => i !== index))} style={{ cursor: 'pointer', marginLeft: '4px' }}>×</MDTypography>
                  </MDBox>
                ))}
              </MDBox>
            </MDBox> */}

            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Role
            </MDTypography>
            <Multiselect
              data={permissions}
              edit_data={[]}
              isMulti={true}
              name="roles"
              onChange={handleRoleChange}
            />

            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Tags
            </MDTypography>
            <Multiselect
              data={team_tags}
              edit_data={[]}
              isMulti={true}
              name="tags"
              onChange={handleRoleChange}
            />

            {/* {selectedRoles?.includes('client') && ( */}
            {/* <> */}
            <MDTypography variant="button" sx={{ fontSize: '14px', fontWeight: '500' }} mb={1}>
              Client App ID
            </MDTypography>
            <MDInput label="AppId" placeholder="App ID" name="app_id" fullWidth />
            {/* </> */}
            {/* )} */}

            <MDBox display="flex" justifyContent="flex-end">
              <MDButton
                variant="gradient"
                color="primary"
                type="button"
                sx={{ mt: 4, mb: 1 }}
                onClick={onClose}
              >
                Close
              </MDButton>
              <MDButton
                variant="gradient"
                color="info"
                type="submit"
                sx={{ mt: 4, mb: 1, ml: 1 }}
                loading={processing}
                disabled={processing}
              >
                Add
              </MDButton>
            </MDBox>
          </MDBox>
        </MDBox>
      </MDModal>
    )
  }

  return (
    <>
      <MDButton color="info" variant="contained" onClick={handlemodal}>
        Create
      </MDButton>
      <AddProduct open={openAddProduct} onClose={closeAddProduct} />
    </>
  )
}

export default CreateModal
